import { type RadioFieldProps, RadioGroupField } from "$components/inputs";
import { useController } from "react-hook-form";

const RHFRadioGroupField: FC<RadioFieldProps> = ({ name, ...restProps }) => {
  const controller = useController({ name });

  return (
    <RadioGroupField
      {...controller.field}
      // We set null here instead of as the default value to the controller so that RHF
      // isn't forced to hold null values, which can be problematic for validation,
      // but MUI is satisfied that the component is controlled on first render.
      value={controller.field.value ?? null}
      error={controller.fieldState.error?.message}
      {...restProps}
    />
  );
};

export default RHFRadioGroupField;
